export default __webpack_public_path__ + "static/media/grafema_pilates_12.8762a8c8.jpg";